import { useTranslation } from 'react-i18next';

interface Product {
  model: string;
  name: string;
  specs: string;
  weight: string;
  volume: string;
  price: number;
  image: string;
}

interface ProductCardProps {
  product: Product;
  index: number;
  onImageClick: () => void;
}

export default function ProductCard({ product, index, onImageClick }: ProductCardProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 border border-gray-100">
      {/* Image Container */}
      <div className="relative aspect-square bg-gray-50 cursor-pointer" onClick={onImageClick}>
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-contain p-4"
        />
        {/* Product Number Badge */}
        <div className="absolute top-3 left-3 w-10 h-10 bg-gray-900 text-white rounded-full flex items-center justify-center font-bold text-sm">
          {index}
        </div>
        {/* Model Badge */}
        <div className="absolute top-3 right-3 bg-[#21C25E] text-white px-3 py-1 rounded-md font-semibold text-sm">
          {product.model}
        </div>
      </div>

      {/* Product Info */}
      <div className="p-4 space-y-3">
        <h3 className="font-bold text-lg text-gray-900 leading-tight min-h-[3.5rem]">
          {product.name}
        </h3>
        
        {product.specs && (
          <p className="text-sm text-gray-600">
            <span className="font-semibold">{t('product.specs')}:</span> {product.specs}
          </p>
        )}
        
        <div className="flex items-center justify-between text-sm text-gray-600">
          <div>
            <span className="font-semibold">{t('product.weight')}:</span> {product.weight}
          </div>
          <div>
            <span className="font-semibold">{t('product.volume')}:</span> {product.volume}
          </div>
        </div>
      </div>
    </div>
  );
}